import { useLocation } from 'react-router-dom';
import querystring from 'querystring';

interface Config {
  VEH: string;
  EXC: string;
  WHL: string;
  INT: string;
  PKG: string;
  ORDER: string | undefined;
  CONFIG_NUM: string | undefined;
  APPONLY: string | undefined;
  WAITLIST: string | undefined;
  REFERRAL_CODE: string | undefined;
  APP_GOBACK_FROM: 'model' | 'options' | 'summary' | undefined;
  FF91_SUBSCRIBE: string | undefined;
  ENTRY_PAGE: string | undefined;
  CURRENT_OPTION: string | undefined;
  EMAIL: string | undefined;
  NO_BACK_BUTTON: string | undefined;
}

/*
* encoding '+' in email parameter in a querystring, 
* Otherwise, the '+' will be replaced with a space.
* for the compatibility, didn't use regEx to do it.
*/
const encodeEmailInQueryString = (queryString: string): string => {
  const qs = queryString.toLowerCase();
  const emailPos = qs.indexOf('email=');
  if(emailPos < 0){
    return queryString;
  }

  const qsBeforeEmail = queryString.substring(0, emailPos);
  let qsEmail = queryString.substring(emailPos);
  let qsAfterEmail = '';

  const ampersandPos = qsEmail.indexOf('&'); // first index of '&'
  if(ampersandPos >= 0){
    qsAfterEmail = qsEmail.substring(ampersandPos);
    qsEmail = qsEmail.substring(0, ampersandPos)
  }

  qsEmail = qsEmail.replace('+', '%2B');

  return `${qsBeforeEmail}${qsEmail}${qsAfterEmail}`;
}

export default function useConfig(): Config {
  const { search } = useLocation();
  // TODO: Replace with URLSearchParams + polyfill
  const {
    VEH,
    EXC,
    WHL,
    INT,
    PKG,
    ORDER,
    CONFIG_NUM,
    APPONLY,
    NO_BACK_BUTTON,
    WAITLIST,
    REFERRALCODE,
    REFERRAL_CODE,
    APP_GOBACK_FROM,
    FF91_SUBSCRIBE,
    ENTRY_PAGE,
    CURRENT_OPTION,
    EMAIL,
  } = querystring.parse(encodeEmailInQueryString(search.replace(/\?/g, '')));
  
  return {
    VEH,
    EXC,
    WHL,
    INT,
    PKG,
    ORDER,
    CONFIG_NUM,
    APPONLY,
    NO_BACK_BUTTON,
    REFERRAL_CODE: REFERRALCODE || REFERRAL_CODE, // retrieve referral code from both fields to avoid bugs.
    WAITLIST,
    APP_GOBACK_FROM,
    FF91_SUBSCRIBE,
    ENTRY_PAGE,
    CURRENT_OPTION,
    EMAIL,
  } as Config;
}
